import { EventType } from "../../Middleware/Tracker"
import { State } from "../../Reducers"
import { selectUser } from "./Selectors/auth"

export function segment(type: EventType) {
    return (...args: any[]) => {
        if (isDoNotTrackEnabled()) return

        const root =
            (typeof window === "object" &&
                window.window === window &&
                window) ||
            (typeof global === "object" && global.global === global && global)
        const analytics = root === false ? undefined : (root as any).analytics

        if (analytics !== undefined && typeof analytics[type] === "function") {
            ;(root as any).analytics[type](...args)
        }
    }
}

export function segmentIdentity(state: State, newUser: boolean = false) {
    const user = selectUser(state)

    if (user === undefined) {
        return
    }

    if (newUser) {
        segment("alias")(user.id)
    }

    segment("identify")(user.id, { email: user.email })
}

/**
 * From: https://gist.githubusercontent.com/zaccolley/b3dc083fdc6f4dee12c233574acbc97a/raw/b55744de1b207eaec40c66dd7c9a57a44edd353a/dnt-client-side-function.js
 */
export function isDoNotTrackEnabled() {
    const doNotTrackOption =
        window.doNotTrack ||
        window.navigator.doNotTrack ||
        (window.navigator as any).msDoNotTrack

    if (!doNotTrackOption) {
        return false
    }

    if (doNotTrackOption.charAt(0) === "1" || doNotTrackOption === "yes") {
        return true
    }

    return false
}
